class BookingCompletedData {
	constructor() {
		if (!BookingCompletedData.instance) {
			this._data = null;
			this._serviceSource = null;
			this._wastesSource = null;
			BookingCompletedData.instance = this;
		}

		return BookingCompletedData.instance;
	}

	set buildName(func) {
		this._buildName = func;
	}

	set objectsGroupBy(func) {
		this._objectsGroupBy = func;
	}

	set setDateNoTz(classCopy) {
		this._DateNoTz = classCopy;
	}

	set serviceSource(s) {
		this._serviceSource = [...s];
	}

	set wastesSource(s) {
		this._wastesSource = [...s];
	}

	set bookingsDatesSource(d) {
		this._bookingsDatesSource = [...d];
	}

	set data(d) {
		if (d) {
			this._data = { ...d };
		}
	}

	get buildSummary() {
		if (this._data && this._data.requestCopy) {
			const arrWorkOrders = this._data.requestCopy.bookings || [];

			let self = this;

			const serviceGroup = this._objectsGroupBy(this._serviceSource, 'api_value');
			const wasteGroup = this._objectsGroupBy(this._wastesSource, 'apiValue');
			const serviceBookingDateGroup = this._objectsGroupBy(this._bookingsDatesSource, 'service_setting_id');

			const combinedGeneratedTicketAndWorkOrders = this._data.bookings.map((generatedCRN, index) => {

				const servicesObject = self._objectsGroupBy(arrWorkOrders[index].workOrders, 'woServiceType');

				let services = [];
				for (let woServiceType in servicesObject) {
					const theService = {};
					const serviceWastes = servicesObject[woServiceType];
					
					theService.wastes = serviceWastes.map((waste, wasteIndex) => {
						const wasteDetail = (wasteGroup[waste.woWasteType] && wasteGroup[waste.woWasteType][0]) || null;
						
						if (wasteDetail) {
							wasteDetail.productNames = { ...wasteDetail.name };
							waste.name = self._buildName(wasteDetail);
						}

						// theService.requestedCompletionDate = waste.requestedCompletionDate;

						return waste;
					});

					const serviceO = serviceGroup[woServiceType] && serviceGroup[woServiceType][0];
					theService.name = (serviceO && serviceO.service_name) || '';

					const service_setting_id = (serviceO && serviceO.service_setting_id) || 0;
					const selectedSchedule = (service_setting_id && serviceBookingDateGroup[service_setting_id] && serviceBookingDateGroup[service_setting_id][0]) || { selectedPeriod: new Date() };
					theService.requestedCompletionDate = this.printBookingDate(selectedSchedule);

					services.push(theService);
				}

				generatedCRN.services = services;
				return generatedCRN;
			});

			return combinedGeneratedTicketAndWorkOrders;
		}

		return [];
	}

	get buildSummaryV2() {
		if (this._data && this._data.requestCopy) {
			const self = this;
			
			// Start Group wastes by service parent
			const services = [];
			const arr_service_setting_id_wastes = this._objectsGroupBy(this._wastesSource, 'service_setting_id');
			
			for (let service_setting_id in arr_service_setting_id_wastes) {
				
				const service_setting_id_wastes = [ ...arr_service_setting_id_wastes[service_setting_id] ];
				
				const serviceDetails = { ...(this._serviceSource.find(_s => _s.service_setting_id === parseInt(service_setting_id)) || { service_name: '' }) };

				const service_setting_id_date = (this._bookingsDatesSource.find(service => service.service_setting_id === parseInt(service_setting_id)) || { selectedPeriod: new Date() });
				
				const isSeparateBookingPerWaste = !!parseInt(serviceDetails.separate_booking_per_waste);

				const theService = {
					api_value: serviceDetails.api_value,
					name: serviceDetails.service_name,
					requestedCompletionDate: this.printBookingDate(service_setting_id_date),
					wastes: service_setting_id_wastes.map(waste => {
						if (!waste.productNames) {
							waste.productNames = { ...waste.name };
						}
						waste.presentationName = self._buildName(waste);
						return waste;
					}),
					isSeparateBookingPerWaste 
				};

				services.push(theService);
			}

			this._servicesAndWastes = services;
			// End Group wastes by service parent

			const combinedGeneratedTicketAndWorkOrders = this._data.bookings.map((generatedCRN, generatedCRNIndex) => {
				generatedCRN.services = [];

				const sentBooking = this._data.requestCopy.bookings[generatedCRNIndex];
				const sentBookingWorkOrders = this._objectsGroupBy(sentBooking.workOrders, 'woServiceType');

				for (let woServiceType in sentBookingWorkOrders) {
					const service_setting_api = woServiceType;

					// Find in compiled service (from above) the same service with same api
					const serviceCompleteDetails = services.find(s => s.api_value === service_setting_api);
					if (serviceCompleteDetails) {
						const service = {
							name: serviceCompleteDetails.name,
							requestedCompletionDate: serviceCompleteDetails.requestedCompletionDate,
							wastes: serviceCompleteDetails.wastes
						};

						/**
						* 2021-02-03 Joseph: DEF_62_S15: Duplicate wastes display in Thank you page
						* When Separate Booking Per Waste is enabled in service, the success booking summary generates
						* multiple CRN (workorder) but waste streams are repeated in each work order group. Each waste
						* stream should be part of their own work order group
						*/
						if (serviceCompleteDetails.isSeparateBookingPerWaste) {
							const woServiceTypeWasteTypes = Object.keys(this._objectsGroupBy(sentBookingWorkOrders[woServiceType], 'woWasteType'));
							service.wastes = serviceCompleteDetails.wastes.filter(w => woServiceTypeWasteTypes.includes(w.apiValue) );
						}

						generatedCRN.services.push(service);
					}
				}

				return generatedCRN;
			});

			return combinedGeneratedTicketAndWorkOrders;
		}

		return [];
	}

	printBookingDate(schedule) {
		if (schedule) {
            if (schedule.selectedPeriod instanceof Date) {
                const theDate = new this._DateNoTz(schedule.selectedPeriod);
                const desc = `${theDate.day} ${theDate.getMonthDescShort()}`;
                return desc;
            }

            const startDate = new this._DateNoTz(schedule.selectedPeriod.start);
            const endDate = new this._DateNoTz(schedule.selectedPeriod.end);
            const desc = `${schedule.selectedPeriod.start.getDate()} ${startDate.getMonthDescShort()} to ${schedule.selectedPeriod.end.getDate()} ${endDate.getMonthDescShort()}`;
            
            return desc;
        }
        return '';
	}
}

module.exports = BookingCompletedData;